import { CanCreate } from 'labstep-web/components/Entity/Can';
import ProtocolCollectionActionCreate from 'labstep-web/components/ProtocolCollection/Action/Create';
import { ProtocolCollection } from 'labstep-web/models/protocol-collection.model';
import type React from 'react';
import { Button, Dropdown } from 'semantic-ui-react';
import ProtocolCollectionActionCreateFromTemplate from '../CreateFromTemplate';
import type { ProtocolCollectionActionCreateMenuProps } from './types';

export const ProtocolCollectionActionCreateMenu: React.FC<
  ProtocolCollectionActionCreateMenuProps
> = (props) => (
  <CanCreate entityName={ProtocolCollection.entityName}>
    <Button.Group color="blue">
      <ProtocolCollectionActionCreate {...props} />
      <ProtocolCollectionActionCreateFromTemplate {...props} />
    </Button.Group>
  </CanCreate>
);
